import { render, staticRenderFns } from "./operadora-fidelizacao.vue?vue&type=template&id=1348157b"
import script from "./operadora-fidelizacao.vue?vue&type=script&lang=ts"
export * from "./operadora-fidelizacao.vue?vue&type=script&lang=ts"
import style0 from "./operadora-fidelizacao.vue?vue&type=style&index=0&id=1348157b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports